import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TimecardService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getTimecardSettings(pRCo: number, pRGroup: number, earnCode: number, isCrewOrStandard: string) {
    var url = "/Timecard/GetTimecardSettings?pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&earnCode=" + earnCode + "&isCrewOrStandard=" + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getDailyTimeGrid(jCJMKeyIDString: string, startDateStr: string, endDateStr: string) {
    var url = "/Timecard/GetDailyTimeGrid?jCJMKeyIDString=" + jCJMKeyIDString + "&startDateStr=" + startDateStr + "&endDateStr=" + endDateStr;
    return this.http.get(url).toPromise();
  }

  createTimecard(jCJMKeyID: number, dateStr: string, phase: string) {
    return this.http.post("/Timecard/CreateTimecard",
      {
        jCJMKeyID: jCJMKeyID,
        dateStr: dateStr,
        phase: phase
      }).toPromise();
  }

  getPointsByTimecardPersistID(timecardPersistID: number, postDateStr?: string) {
    var url = "/Timecard/GetPointsByTimecardPersistID?timecardPersistID=" + timecardPersistID;
    if (postDateStr != null) {
      url += "&postDateStr=" + postDateStr;
    }
    return this.http.get(url).toPromise();
  }

  getJobLocationPoints(timecardPersistID: number, postDateStr?: string) {
    var url = "/Timecard/GetJobLocationPoints?timecardPersistID=" + timecardPersistID;
    if (postDateStr != null) {
      url += "&postDateStr=" + postDateStr;
    }
    return this.http.get(url).toPromise();
  }

  getMapCoordinates(address: string) {
    var url = "/Timecard/GetMapCoordinates?address=" + address;
    return this.http.get(url).toPromise();
  }

  getWeeksByPRPCKeyID(pRPCKeyID: number) {
    var url = "/Timecard/GetWeeksByPRPCKeyID?pRPCKeyID=" + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  getDailyTime(pREHKeyID?: number, employeeString?: string, pRPCKeyID?: number, startDateString?: string, endDateString?: string, includeClockOutSigs?: boolean) {
    let url = "/Timecard/GetDailyTime?pREHKeyID=" + pREHKeyID + "&pRPCKeyID=" + pRPCKeyID;
   
    if (employeeString != null) {
      url += "&employeeString=" + employeeString;
    }
    if (startDateString != null) {
      url += "&startDateString=" + startDateString;
    }
    if (endDateString != null) {
      url += "&endDateString=" + endDateString;
    }
    if (includeClockOutSigs != null) {
      url += "&includeClockOutSigs=" + includeClockOutSigs;
    }
    return this.http.get(url).toPromise();
  }

  getAttachmentList(pRTBKeyID: number) {
    var url = "/Timecard/GetAttachmentList?pRTBKeyID=" + pRTBKeyID;
    return this.http.get(url).toPromise();
  }

  getTimecard(employeeId: number, timecardId: number, hQBCKeyID: number) {
    const url = '/Timecard/GetTimecard?employeeId=' + employeeId + '&timecardId=' + timecardId + '&hQBCKeyID=' + hQBCKeyID;
    return this.http.get(url).toPromise();
  }

  deleteVPAttachment(attachmentID: number, uniqueAttchID?: any, database?: boolean) {
    return this.http.post("/Document/DeleteVPAttachment",
      {
        attachmentID: attachmentID,
        uniqueAttchID: uniqueAttchID,
        database: database
      }).toPromise();
  }

  cloneTimecard(employeeId: number, timecardId: number) {
    return this.http.post("/Timecard/CloneTimecard",
      {
        employeeId: employeeId,
        timecardId: timecardId,
      }).toPromise();
  }

  getQuestions(timecardGroupID: number) {
    const url = '/Timecard/GetQuestions?timecardGroupID=' + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  submitTimecard(requestObj: any) {
    return this.http.post("/Timecard/SubmitTimecard",
      {
        employeeId: requestObj.employeeId,
        timecardId: requestObj.timecardId,
        payPeriodID: requestObj.payPeriodID,
        submit: requestObj.submit,
        submitSignatureStr: requestObj.submitSignatureStr,
        submitNoIssues: requestObj.submitNoIssues,
        submitIssuesNotes: requestObj.submitIssuesNotes,
        longitude: requestObj.longitude,
        latitude: requestObj.latitude,
        submittedOnString: requestObj.submittedOnString,
        questionRow: requestObj.questionRow
      }).toPromise();
  }

  approveTimecard(requestObj: any) {
    return this.http.post("/Approval/ApproveTimecard",
      {
        prehKeyId: requestObj.prehKeyId,
        hqbcKeyId: requestObj.hqbcKeyId,
        prpcKeyId: requestObj.prpcKeyId,
        memo: requestObj.memo,
        crewTemplateID: requestObj.crewTemplateID,
        submitSignature: requestObj.submitSignature,
        longitude: requestObj.longitude,
        latitude: requestObj.latitude,
        submittedOnString: requestObj.submittedOnString,
        questionResponseXML: requestObj.questionResponseXML
      }).toPromise();
  }

  rejectTimecard(requestObj: any) {
    return this.http.post("/Approval/RejectTimecard",
      {
        prehKeyId: requestObj.prehKeyId,
        hqbcKeyId: requestObj.hqbcKeyId,
        prpcKeyId: requestObj.prpcKeyId,
        memo: requestObj.memo,
        submitSignature: requestObj.submitSignature,
        crewTemplateID: requestObj.crewTemplateID,
        longitude: requestObj.longitude,
        latitude: requestObj.latitude,
        submittedOnString: requestObj.submittedOnString,
        questionResponseXML: requestObj.questionResponseXML
      }).toPromise();
  }

  addVPAttachment(requestObj: any) {
    return this.http.post("/Document/AddVPAttachment",
      {
        fileName: requestObj.fileName,
        fileDescription: requestObj.fileDescription,
        fileData: requestObj.fileData,
        moduleID: requestObj.moduleID,
        recordKeyID: requestObj.recordKeyID,
        fileAttachmentID: requestObj.fileAttachmentID,
        fileAttachmentType: requestObj.fileAttachmentType,
        recordGuid: requestObj.recordGuid,
        attachmentType: requestObj.attachmentType,
        attachmentDescription: requestObj.attachmentDescription
      }).toPromise();
  }

  createTimecardRow(requestObj: any) {
    return this.http.post("/Timecard/CreateTimecardRow",
      {
        employeeId: requestObj.employeeId,
        timecardId: requestObj.timecardId,
        row: requestObj.row,
        crewTemplateID: requestObj.crewTemplateID,
        fromJobApproval: requestObj.fromJobApproval,
        hideResults: requestObj.hideResults
      }).toPromise();
  }

  updateTimecardRow(requestObj: any) {
    return this.http.post("/Timecard/UpdateTimecardRow",
      {
        employeeId: requestObj.employeeId,
        timecardId: requestObj.timecardId,
        row: requestObj.row,
        employee: requestObj.employee,
        fromJobApproval: requestObj.fromJobApproval,
        hideResults: requestObj.hideResults,
        crewTemplateID: requestObj.crewTemplateID
      }).toPromise();
  }

  getTimecardRow(rowId: number) {
    const url = "/Timecard/Row?rowId=" + rowId;
    return this.http.get(url).toPromise();
  }

  deleteTimecardRow(rowId: number) {
    return this.http.post("/Timecard/DeleteTimecardRow",
      {
        rowId: rowId
      }).toPromise();
  }

  insertUpdateTime(pREHKeyID: number, pRPCKeyID: number, dateWorkedString: string, startTimeString: string, stopTimeString: string, seq: number, notes: string, employee?: number, breakHours?: number) {
    return this.http.post("/Timecard/InsertUpdateTime",
      {
        pREHKeyID: pREHKeyID,
        pRPCKeyID: pRPCKeyID,
        dateWorkedString: dateWorkedString,
        startTimeString: startTimeString,
        stopTimeString: stopTimeString,
        seq: seq,
        notes: notes,
        employee: employee,
        breakHours: breakHours
      }).toPromise();
  }

  async getTimecardRows(params: HttpParams): Promise<GetRowsResponse> {
    return this.http.get<Promise<GetRowsResponse>>("/timecard/rows", { params: params }).toPromise();
  }

  getTimecardColumns(employeeId: number, employee?: number, pRCo?: number, filterType?: string, isCrewOrStandard?: string) {
    let url = "/Timecard/GetTimecardColumns?employeeId=" + employeeId;
    if (employee != null) {
      url += "&employee=" + employee;
    }
    if (pRCo != null) {
      url += "&pRCo=" + pRCo;
    }
    if (filterType != null) {
      url += "&filterType=" + filterType;
    }
    if (isCrewOrStandard != null) {
      url += "&isCrewOrStandard=" + isCrewOrStandard;
    }
    return this.http.get(url).toPromise();
  }

  async getEmployees(params: HttpParams): Promise<Employee[]> {
    return this.http.get<Promise<Employee[]>>("/Timecard/GetEmployees", { params: params }).toPromise();
  }

  getPayPeriodDetails(prpcKeyID: number, isCrewOrStandard: string) {
    const url = "/Timecard/GetPayPeriodDetails?prpcKeyID=" + prpcKeyID + "&isCrewOrStandard=" + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  async getPayPeriods(employeeId: number) {
    const url = "/Timecard/GetPayPeriods?employeeId=" + employeeId;
    return this.http.get(url).toPromise();
  }

  getCellPossibleValues(row: any, column: string, payPeriod?: number, prehKeyID?: number, employee?: string, isDebugMode?: boolean, searchString?: string) {
    return this.http.post("/Timecard/GetCellPossibleValues",
      {
        row: row,
        column: column,
        payPeriod: payPeriod,
        prehKeyID: prehKeyID,
        employee: employee,
        isDebugMode: isDebugMode,
        searchString: searchString
      });
  }

  async getLeaveCodesByPrehKeyID(params: HttpParams): Promise<any> {
    return this.http.get<Promise<any>>("/Timecard/GetLeaveCodesByPrehKeyID", { params: params }).toPromise();
  }

  getDailyOtherHours(pRCo?: string, pREHKeyID?: number, pRPCKeyID?: number, crewTemplateID?: number) {
    let url = "/Timecard/GetDailyOtherHours?";
    if (pRCo != null) {
      url += "pRCo=" + pRCo;
    }
    if (pREHKeyID != null) {
      url += "&pREHKeyID=" + pREHKeyID;
    }
    if (pRPCKeyID != null) {
      url += "&pRPCKeyID=" + pRPCKeyID;
    }
    if (crewTemplateID != null) {
      url += "&crewTemplateID=" + crewTemplateID;
    }
    return this.http.get(url).toPromise();
  }

  getSMTimecardLock() {
    const url = "/Timecard/GetSMTimecardLock";
    return this.http.get(url).toPromise();
  }

}

export interface PayPeriod {
  HQBCKeyID: number | null;
  PRPCKeyID: number;
  PREndDate: string;
  StandardHours: number;
  IsPayPeriodCurrent: boolean | null;
  TimecardGroupID: number;
};

export interface PayPeriodDetails {
  // start and end date should be changed to string only at some point
  StartDate: string | Date;
  EndDate: string | Date;
  ConstrainPostDateToPayPeriod: boolean;
  DateDefaultValue: string;
};

export interface Employee {
  PRCo: string;
  Employee: number;
  PRGroup: number;
  FirstName: string;
  LastName: string;
  PREHKeyID: number;
  UnionResultGroup: number;
  IsPM: number;
  UserKeyID: number | null;
  CompanyName: string;
  GroupSort: number;
  IsApprover: boolean | null;
  DisplayValue: string | null;
  EmployeeId: number | null;
  employeeGroup: string | null;
};

export interface Timecard {
  TimecardPersistID: number;
  PREHKeyID: number;
  HQBCKeyID: number;
  PRPCKeyID: number;
  DateSubmitted: Date;
  DateApproved: Date;
  IsSubmitted: boolean;
  SubmittedByName: string;
  ApprovedByName: string;
  IsApproved: boolean;
  IsLocked: boolean;
  IsCloneEnabled: boolean;
  IsDebugModeOn: boolean;
  EmplSignatureAttachmentTypeID: string;
  DefaultHoursPerPeriod: number;
  DefaultWeeksPerPeriod: number;
  IsPayPeriodBoundaryEnforced: boolean;
  IsTimeWorkedEnabled: boolean;
  NewLinePostDateBehavior: string;
  DefaultLineType: string;
  ReadOnly?: boolean;
};

export interface TimecardRow {
  Co: string;
  Mth: Date;
  BatchId: string;
  BatchSeq: string;
  BatchTransType: string;
  Employee: string;
  PaySeq: string;
  Type: string;
  DayNum: string;
  PostDate: Date;
  JCCo: string;
  Job: string;
  PhaseGroup: string;
  Phase: string;
  GLCo: string;
  EMCo: string;
  Equipment: string;
  EMGroup: string;
  RevCode: string;
  EquipCType: string;
  UsageUnits: string;
  TaxState: string;
  UnempState: string;
  InsState: string;
  PRDept: string;
  Cert: string;
  Craft: string;
  Class: string;
  EarnCode: string;
  Shift: string;
  Hours: string;
  Memo: string;
  EquipPhase: string;
  KeyID: string;
  BreakHours: string;
  JCCoJobCombined: string;
  JobPhaseCombined: string;
  PRTBUDKeyID: string;
  udCheckBox: string;
  udGridCheck: string;
  HasAttachments: string;
  // Fields below added in the timecard component, move to extended interface in component file
  cells?: any;
  invalidEquipment?: boolean;
  invalidRevCode?: boolean;
  invalidWOItem?: boolean;
  invalidPhaseJob?: boolean;
};

export interface GetRowsResponse {
  Timecard?: TimecardRow[];
  Item?: TimecardRow;
};

export interface TimecardColumn {
  length: number;
  ColumnSettingID?: number;
  ColumnName: string;
  Form?: string;
  Seq?: number;
  PRCo?: number;
  ColumnVisibilityModeID: number;
  FieldNameOverride?: string;
  ColumnLabel: string;
  StatusText?: string;
  IsRequired?: boolean;
  InputLength?: number;
  EffectsPossibleValues: boolean;
  Datatype: string;
  ComboType?: string;
  SortSequence?: number;
  IsCombo: number;
  DefaultValue?: string;
  ApproximateWidth: number;
  ValidationDataType?: string;
  NewLineTypeID?: number;
  IsAutoSelectFirstValue?: boolean;
  RefreshLineOnChange: number;
  LineType: string;
  DependentColumns?: string;
  IsSearchableOnMobile?: boolean;
  DefaultLabel?: string;
  ColumnWidthOvr?: number;
  ApprovalVisibilityModeID: number;
};

export enum ColumnMode {
  Hidden = 1,
  Readonly = 2,
  Editable = 3,
};

